import { BusinessFuel } from '../../business/models/business-fuel.model';
var FuelComponent = /** @class */ (function () {
    function FuelComponent() {
    }
    Object.defineProperty(FuelComponent.prototype, "type", {
        /**
         * Returns formatted fuel type
         */
        get: function () {
            return BusinessFuel.formatFuelType(this.fuel.fuelType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FuelComponent.prototype, "serviceType", {
        /**
         * Returns formatted service type
         */
        get: function () {
            return BusinessFuel.formatServiceTypeShort(this.fuel.service);
        },
        enumerable: true,
        configurable: true
    });
    return FuelComponent;
}());
export { FuelComponent };
